module.exports = __webpack_public_path__ + "img/cgm medical.7a4da53f.png";